import React from 'react';
import SiteWrapper from '../../SiteWrapper.react';
import RuteadorContent from './RuteadorContent';

const RuteadorPage = () => {
  const params = new URLSearchParams(window.location.search);
  return (
    <SiteWrapper>
      <div style={{ width: '100%', height: 'calc(100vh - 60px)' }}>
        <RuteadorContent
          initialOrigen={params.get('origen') || ''}
          initialDestino={params.get('destino') || ''}
          height="100%"
        />
      </div>
    </SiteWrapper>
  );
};

export default RuteadorPage;
